import { createElement } from 'react';
import './index.scss';
import { Breadcrumb } from '@alifd/next';
const BreadCrumb = ({ dataList, itemList, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const renderItems = () => {
        if (dataList?.length > 0) {
            return dataList.map((item, index) => (createElement(Breadcrumb.Item, { key: index, link: item.link }, item.name)));
        }
        if (itemList?.length > 0) {
            return itemList.map((item, index) => (createElement(Breadcrumb.Item, { key: index, link: item.link }, item.name)));
        }
        return createElement(Breadcrumb.Item, null, "\u6682\u65E0\u6570\u636E");
    };
    return createElement(Breadcrumb, { ..._otherProps }, renderItems());
};
BreadCrumb.displayName = 'BreadCrumb';
export default BreadCrumb;
